import { render, staticRenderFns } from "./NoteForm.vue?vue&type=template&id=382b7138&"
import script from "./NoteForm.vue?vue&type=script&lang=js&"
export * from "./NoteForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports